import { getWindow } from "@faire/web--source/common/globals/getWindow";
import { trackRetailerMobileAppsflyerOnelinkFailed } from "@faire/web-api--source/events/retailerMobile/actionUnknown/appsflyerOnelinkFailed";
import { IAppPromotionBannerLinks } from "@faire/web-api--source/indigofair/data/IAppPromotionBannerLinks";

import { getSettingAppPromotionBannerLinks } from "@faire/retailer-visitor-shared/settings/getSettingAppPromotionBannerLinks";

export const getStoreLinkUrl = (): IAppPromotionBannerLinks => {
  return getSettingAppPromotionBannerLinks();
};

export const getAppsFlyerOrStoreLinks = (): IAppPromotionBannerLinks => {
  // AF_SMART_SCRIPT is a script added to Google Tag Manager on prod
  // Manually inject script to test on local/staging
  // doc: https://dev.appsflyer.com/hc/docs/onelink-smart-script-v2web-to-app-url-generator#create-a-qr-code-with-the-smart-script-result
  // script: https://tagmanager.google.com/?authuser=1#/container/accounts/1798415649/containers/7538127/workspaces/1000085/tags/140
  const appsFlyerUrl = getWindow()?.AF_SMART_SCRIPT_RESULT?.clickURL;

  if (appsFlyerUrl) {
    return IAppPromotionBannerLinks.build({
      app_store_link: appsFlyerUrl,
      play_store_link: appsFlyerUrl,
    });
  }

  trackRetailerMobileAppsflyerOnelinkFailed();
  return getStoreLinkUrl();
};
